import { IFileKeys } from "@interface/ICommon";

export const translations = {
  th: "th",
  en: "en",
  bn: "bn",
  hi: "hi",
  km: "km",
  "kn-IN": "kn_IN",
  lo: "lo",
  "mr-IN": "mr_IN",
  my: "my",
  "ta-IN": "ta_IN",
  "te-IN": "te_IN",
  "tl-PH": "tl_PH",
  vi: "vi",
};

export const translationData = (
  translationKeys: string[],
  FileKeys: IFileKeys
) =>
  Object.fromEntries(
    Object.entries(translations).map(([lang, suffix]) => [
      lang,
      Object.fromEntries(
        translationKeys.map((key) => {
          const splitHyphen = key.split('-').join("")
          const fileKey = `${splitHyphen}_${suffix}`;
          return [key, FileKeys[fileKey]];
        })
      ),
    ])
  );
